import Vue from 'vue';

export default {
  state: {
    agreementStatuses: [],
  },
  getters: {
    agreementStatuses(state) {
      return state.agreementStatuses;
    },
    agreementStatusById: state => id =>
      state.agreementStatuses.find(item => item.id === id) || {},
  },
  mutations: {
    SET_AGREEMENT_STATUSES(state, payload) {
      state.agreementStatuses = payload;
    },
  },
  actions: {
    GET_AGREEMENT_STATUSES({ commit }) {
      return Vue.axios.get('statuses', { params: { entity_id: 3 } })
        .then(({ data }) => commit('SET_AGREEMENT_STATUSES', data.data || []));
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/entity_statuses.js